import styled from "styled-components";
import { Checkbox } from "antd";

export const Wrapper = styled(Checkbox)`
  & span[class~="ant-checkbox-checked"] span[class~="ant-checkbox-inner"] {
    background-color: var(--primary-red-color) !important;
    border-color: var(--primary-red-color) !important;
  }
`;
